import {
    Box,
    Button,
    Grid,
    IconButton,
    InputBase,
    Typography,
  } from "@mui/material";
  import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
  import { useEffect, useState } from "react";
  import { Link, NavLink } from "react-router-dom";
  import { useNavigate } from "react-router-dom";
  import AppBar from "@mui/material/AppBar";
  import Cookies from "js-cookie";
  import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../AxiosBaseApi";
//   import axiosInstance from "../../AxiosBaseApi";
  
  const PersonalInfo = () => {
    const history = useNavigate();
    const [loginStatus, setLoginStatus] = useState(false);
    const [selectedTab, setSelectedTab] = useState("lottery");
      const [data, SetData] = useState("");
    const [userInfo, setUserInfo] = useState({
      user: {},
      totalRecharge: 0,
      totalWithdraw: 0,
    });
    const [amount, setAmount] = useState(300); // default value
    const quickAmounts = [1, 500, 1000, 10000, 100000, 1000000]; // quick money options
  
    const handleManualUPIPaymentRequest = async (amount) => {
      window.location.href = `/wallet/paynow/manual_upi?am=${amount}`;
    };
  
    const handleAmountClick = (value) => {
      setAmount(value);
    };
  
    const handleInputChange = (e) => {
      setAmount(e.target.value);
    };
    const getUserData = async (uid) => {
      try {
        const response = await axiosInstance
          .get(`/bet.php?action=getuserinfo&user=${uid}`)
  
          .then((res) => {
            if (res.status === 200) {
              SetData(res.data);
            } else {
              alert(res.data.message);
            }
          });
      } catch (error) {
        console.log("Error", error);
      }
    };
  
    useEffect(() => {
      const token = localStorage.getItem("mamberId");
      if (!token) {
        history("/login");
      } else {
        getUserData(token);
      }
    }, []);
  
    const handleTabClick = (tabId) => {
      setSelectedTab(tabId);
    };
    const logOut = () => {
      localStorage.clear();
      history("/login");
    };
    return (
      <>
        <div style={{ width: "100%",  }}>
          <Box sx={{ marginBottom: "5px" }}>
            <AppBar
              position="static"
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "2px 10px",
                height: "3.22667rem",
                boxShadow: "unset",
                background: "#3d3b6f",
              }}
            >
              <Box onClick={() => history(-1)} style={{ textDecoration: "none" }}>
                <ChevronLeftIcon
                  fontSize="medium"
                  style={{
                    // width: "60px",
                    color: "#fff",
                    border: "1px solid #f2f3f5",
                    borderRadius: 50,
                  }}
                />
              </Box>
              <Typography style={{ color: "#fff", fontSize: "18px" }}>
                Personal Information
              </Typography>
  
              <Box>
             
              </Box>
            </AppBar>
          </Box>
  
          {/*Slider   */}
          <Grid
            container
            direction="column"
            sx={{ maxHeight: { xs: 190, sm: 250, md: 270, lg: 340 } }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              style={{
                width: "95%",
                marginTop: "5px",
                backgroundImage: "url(./images/bgimgrec.png)",
                minHeight: "150px",
                backgroundSize: "contain", // Makes sure the image scales without being distorted
                backgroundRepeat: "no-repeat", // Prevents image repetition
                backgroundPosition: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: 20,
              }}
            >
              <Box style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <Typography style={{ fontSize: "16px", color: "#fff" }}>
                  Account:    {data[0]?.username}
                </Typography>
              </Box>
              <Box style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <Typography style={{ fontSize: "14px", color: "#fff" }}>
                  NickName:     {data[0]?.nickname}
                </Typography>
              </Box>
              <Box style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <Typography style={{ fontSize: "14px", color: "#fff" }}>
                  Invitation code: {data[0]?.usercode}
                </Typography>
              </Box>
             
            </Grid>
          </Grid>
          <Box style={{display:'flex', flexDirection:'column', gap:5}}>

 
          <Box
            sx={{
              width: "90%",
              margin: "0 20px",
              // position: "relative",
              // top: "-3rem",
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <Box
              onClick={() => history("/personaldetail")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <Box
                style={{
                  paddingLeft: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <img
                  style={{ width: "35px" }}
                  src="/images/img23.png"                />
                <Typography style={{ fontSize: "16px" }}>
                  Detailed information
                </Typography>
              </Box>
              <Box>
                <IconButton>
                  <ArrowForwardIosIcon
                    style={{
                      color: "var(--Lottery4dTextColor-1)",
                      width: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "90%",
              margin: "0 20px",
              // position: "relative",
              // top: "-3rem",
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <Box
            onClick={() => history("/paymentpassword")}
            
              style={{
                display: "flex",
                justifyContent: "space-between",
                 alignItems:'center',
                padding: "0 10px",
              }}
            >
              <Box
                style={{
                //   paddingLeft: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <img
                  style={{ width: "60px" }}
                  src="/images/img9.png"
                   />
                <Typography style={{ fontSize: "16px" }}>
                  Payment Password
                </Typography>
              </Box>
              <Box>
                <IconButton>
                  <ArrowForwardIosIcon
                    style={{
                      color: "var(--Lottery4dTextColor-1)",
                      width: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "90%",
              margin: "0 20px",
              // position: "relative",
              // top: "-3rem",
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <Box
              onClick={() => history("/loginpassword")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems:'center',
                padding: "0 10px",
              }}
            >
              <Box
                style={{
                //   paddingLeft: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <img
                  style={{ width: "60px" }}
                  src="/images/img9.png"                />
                <Typography style={{ fontSize: "16px" }}>
                  Login Password
                </Typography>
              </Box>
              <Box>
                <IconButton>
                  <ArrowForwardIosIcon
                    style={{
                      color: "var(--Lottery4dTextColor-1)",
                      width: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "90%",
              margin: "0 20px",
              // position: "relative",
              // top: "-3rem",
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <Box
             onClick={() => history("/clear")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <Box
                style={{
                  paddingLeft: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <img
                  style={{ width: "35px" }}
                  src="/images/img23.png"                />
                <Typography style={{ fontSize: "16px" }}>
                  Clear Cache
                </Typography>
              </Box>
              <Box>
                <IconButton>
                  <ArrowForwardIosIcon
                    style={{
                      color: "var(--Lottery4dTextColor-1)",
                      width: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "90%",
              margin: "0 20px",
              // position: "relative",
              // top: "-3rem",
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <Box
              onClick={() => logOut()}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
              }}
            >
              <Box
                style={{
                  paddingLeft: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <img
                  style={{ width: "35px" }}
                  src="/images/img23.png"                />
                <Typography style={{ fontSize: "16px" }}>
                  Log out
                </Typography>
              </Box>
              <Box>
                <IconButton>
                  <ArrowForwardIosIcon
                    style={{
                      color: "var(--Lottery4dTextColor-1)",
                      width: "20px",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
          </Box>
     
        </div>
      </>
    );
  };
  
  export default PersonalInfo;
  